import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { markFormControlAsDone } from './utils';

@Injectable()
export class ApFormService {
    /**
     * Validate form group and set to touched and dirty state.
     * This will show error messages if any are present
     * @returns {boolean} - Is form valid?
     */
    public verify(formGroup: AbstractControl): boolean {
        markFormControlAsDone(formGroup);
        return formGroup.valid;
    }

    /**
     * Return verify as a Observable
     * It will call verify and check the status of the formGroup to be VALID
     * @param formGroup
     */
    public verify$(formGroup: AbstractControl): Observable<boolean> {
        markFormControlAsDone(formGroup);

        if (formGroup.status !== 'PENDING') {
            return new BehaviorSubject(formGroup.status === 'VALID').pipe(take(1));
        }

        return formGroup.statusChanges.pipe(
            filter((status: string) => status !== 'PENDING'),
            map((status: string) => status === 'VALID'),
            take(1)
        );
    }
}
